import { createAction, props } from '@ngrx/store';

const areaIsCreated = 'AREA_IS_CREATED';
const removeRecentArea = 'REMOVE_RECENT_AREA';
export const areaIsCreatedAction = createAction(
  areaIsCreated,
  props<{ newArea: any }>()
);

export const removeRecentAreaAction = createAction(removeRecentArea);
